import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgDragSource = (props, ref) => /* @__PURE__ */ jsxs("svg", { width: 8, height: 12, viewBox: "0 0 6 10", fill: "inherit", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: [
  /* @__PURE__ */ jsx("circle", { cx: 1, cy: 1, r: 1 }),
  /* @__PURE__ */ jsx("circle", { cx: 1, cy: 5, r: 1 }),
  /* @__PURE__ */ jsx("circle", { cx: 1, cy: 9, r: 1 }),
  /* @__PURE__ */ jsx("circle", { cx: 5, cy: 1, r: 1 }),
  /* @__PURE__ */ jsx("circle", { cx: 5, cy: 5, r: 1 }),
  /* @__PURE__ */ jsx("circle", { cx: 5, cy: 9, r: 1 })
] });
const ForwardRef = forwardRef(SvgDragSource);
export { ForwardRef as ReactComponent };
